import React from 'react';
import { proofNotes, proofStats } from '../data/landing';
import { StarRating } from './StarRating';
export function ProofSection() {
  return <section className="bg-ink px-5 pb-16" data-id="element-173" data-mp="2v30odiihimw8">
      <div className="mx-auto max-w-6xl" data-id="element-174" data-mp="301alvzrolzl0">
        <div className="grid grid-cols-2 border border-gold/25 bg-ink-mid sm:grid-cols-4" data-id="element-175" data-mp="3008z4y1azong">
          {proofStats.map(({
          value,
          label
        }) => <div key={label} className="border-b border-r border-gold/15 px-4 py-6 text-center last:border-r-0 sm:border-b-0" data-id="element-176" data-mp="39zzwr8l5ujrr">
              <p className="font-display text-4xl font-bold uppercase text-gold sm:text-5xl" data-id="element-177" data-mp="3dzs2ldj66btf">
                {value}
              </p>
              <p className="mt-1 text-[10px] font-bold uppercase tracking-widest text-slate-300" data-id="element-178" data-mp="3nr4wsbsfxe2m">
                {label}
              </p>
            </div>)}
        </div>
        <div className="mt-10 grid gap-4 md:grid-cols-3" data-id="element-179" data-mp="3sooddicm22xq">
          {proofNotes.map(({
          quote,
          name,
          role
        }) => <figure key={name} className="flex flex-col border border-gold-dark/20 bg-white p-6" data-id="element-180" data-mp="15n8e88p9qqkq">
              <StarRating className="mb-4" data-id="element-181" data-mp="10nnehw29ye6y" />
              <blockquote className="flex-1 text-sm font-medium italic leading-relaxed text-ink" data-id="element-182" data-mp="vpc33gwbzvmm">
                “{quote}”
              </blockquote>
              <figcaption className="mt-5 border-t border-gold-dark/20 pt-4 text-sm font-bold text-ink" data-id="element-183" data-mp="rp1vy0wsyz66">
                {name}
                <span className="ml-2 text-xs font-medium text-slate-600" data-id="element-184" data-mp="1og3t1wmszo1i">
                  {role}
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}